import React from "react";

const IndicadoresBlog = () => {
  return (
    <section>
    
      <iframe src="https://datastudio.google.com/embed/u/0/reporting/ea19b951-5b40-438d-b716-394a12821b7b/page/qlD" frameborder="0" allowFullScreen="true"></iframe>
    </section>
  );
};

export default IndicadoresBlog;
